import './TiersTableMobile.scss'
import React from 'react';
import { Accordion as BaseAccordion, Card } from 'react-bootstrap';
import {
  FCFSHeader,
  GuaranteedBody,
  GuaranteedHeader,
  LightAccordion,
  noCooldown,
  sevenDayCooldown,
  TierAccordion
} from '@components/common/TiersTableMobile/TiersComponents'
import { ArrowIcon, CustomToggle } from '@/components';
import { TierEntity } from '@api/tiers/types'


export const TiersTableMobile = (props: { tiers: TierEntity[] }) => (
  <div>
    <LightAccordion
      tier={props.tiers.find(t => t.name === 'LIGHT')!}
      tickets="10"
      cooldown={sevenDayCooldown}
    />
    <BaseAccordion key="tiers">
      <Card className="tiers-mobile-accordion">
        <Card.Header>
          <CustomToggle eventKey="tiers">
            <FCFSHeader />
            <ArrowIcon />
          </CustomToggle>
        </Card.Header>
        <BaseAccordion.Collapse eventKey="tiers">
          <Card.Body className="fcfs">
            <TierAccordion
              tier={props.tiers.find(t => t.name === 'SPARK')!}
              tickets="1-9"
              cooldown={sevenDayCooldown}
            />
            <TierAccordion
              tier={props.tiers.find(t => t.name === 'SMOKE')!}
              tickets="10-19"
              cooldown={sevenDayCooldown}
            />
            <TierAccordion
              tier={props.tiers.find(t => t.name === 'FIRE')!}
              tickets="20-49"
              cooldown={sevenDayCooldown}
            />
            <TierAccordion
              tier={props.tiers.find(t => t.name === 'FLAME')!}
              tickets="50+"
              cooldown={noCooldown}
            />
          </Card.Body>
        </BaseAccordion.Collapse>
      </Card>
    </BaseAccordion>
    <BaseAccordion key="guaranteed">
      <Card className="tiers-mobile-accordion">
        <Card.Header>
          <CustomToggle eventKey="guaranteed">
            <GuaranteedHeader />
            <ArrowIcon />
          </CustomToggle>
        </Card.Header>
        <BaseAccordion.Collapse eventKey="guaranteed">
          <Card.Body>
            <GuaranteedBody />
          </Card.Body>
        </BaseAccordion.Collapse>
      </Card>
    </BaseAccordion>
  </div>
);
